// extracted by mini-css-extract-plugin
module.exports = {"mainSpan":"AndicarSpan_mainSpan__3K0CJ","andiColor":"AndicarSpan_andiColor__3xH75","carColor":"AndicarSpan_carColor__2a6os"};